<template>
  <div class="addFeeding">
    <div class="add-content-container">
      <div class="add-titieMain">
        <div class="add-title-container">喂养记录单</div>
        <div class="add-content">
          <div class="operation-btn">
            <el-button
              size="small"
              class="del"
              @click="onDelete"
              :disabled="enableTable || !edit"
            >删除</el-button>
            <el-button
              size="small"
              class="add"
              @click="onAdd"
              :disabled="enableTable || !edit"
            >增加</el-button>
            <el-button
              size="small"
              class="alter"
              @click="onAlter"
              :disabled="enableTable || !edit"
            >修改</el-button>
            <el-button
              size="small"
              class="save"
              v-throttle-button="onSave"
              :disabled="!enableTable || !edit"
            >保存</el-button>
            <el-button
              size="small"
              class="cancel"
              @click="onRollBack"
              :disabled="!enableTable || !edit"
            >撤销</el-button>
            <el-button
              size="small"
              class="close"
              @click="closeView"
            >关闭</el-button>
          </div>
          <div
            class="custom-search-container"
            style="margin-top: 15px"
            :class="{ 'auto-lock': isAutoOrder }"
            @click="onLockedAreaClick"
          >
            <div class="custom-search-box base-search-box">
              <div class="custom-search-box-warpper base-search-box-wrapper">
                <span>
                  <font style="opacity: 0">啊</font>基地
                </span>
                <el-select
                  v-model="order.fishBaseId"
                  filterable
                  placeholder="请选择"
                  size="small"
                  @change="baseChange"
                  :disabled="Boolean(orderId) || edit == false"
                >
                  <el-option
                    v-for="(item, index) in baseLists"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
                <div class="base-pond-box">
                  <el-select
                    v-model="order.pond"
                    filterable
                    placeholder="请选择"
                    size="small"
                    @change="topPondChange"
                    :disabled="Boolean(orderId) || !edit"
                  >
                    <el-option
                      v-for="(item, index) in topPondList"
                      :key="index"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                  <template v-if="order.pond != ''">
                    <span class="pond-batch-label">周期</span>
                    <el-select
                      v-model="order.fishBatchId"
                      class="pond-batch-select allow-edit"
                      filterable
                      placeholder="请选择"
                      size="small"
                      :disabled="edit == false"
                      @change="headerBatchChange"
                    >
                      <el-option
                        v-for="(item, index) in pondBatchList"
                        :key="index"
                        :label="item.value"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>
                  </template>
                </div>
              </div>
              <div
                class="custom-search-box-warpper"
                :style="{ marginLeft: order.pond ? -215 + 'px' : -155 + 'px' }"
              >
                <span>
                  <font style="opacity: 0">啊啊</font>日期
                </span>
                <el-date-picker
                  size="small"
                  v-model="order.dataDate"
                  :disabled="edit == false || isAutoOrder"
                  type="date"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerTimeOptions"
                >
                </el-date-picker>
              </div>
              <div class="custom-search-box-warpper">
                <span>单据号</span>
                <el-input
                  placeholder="请输入单据号"
                  v-model="order.billsNo"
                  size="small"
                  disabled
                >
                </el-input>
              </div>

              <!-- 仓库下拉 - 暂时隐藏
              <div
                class="custom-search-box-warpper"
                v-if="$store.state.curCompany.isQlwVersion == true"
              >
                <span>仓库</span>
                <el-select
                  v-model="order.warehouseName"
                  filterable
                  placeholder="请选择"
                  size="small"
                  :disabled="edit == false"
                >
                  <el-option
                    v-for="(item, index) in storeHouseList"
                    :key="index"
                    :label="item.warehouseName"
                    :value="item.warehouseName"
                  >
                  </el-option>
                </el-select>
              </div>
              -->
            </div>
            <div class="custom-search-box">
              <div
                class="custom-search-box-warpper"
                v-if="show"
              >
                <span>流水号</span>
                <el-input
                  placeholder="请输入流水号"
                  v-model="order.numericalOrder"
                  size="small"
                  disabled
                >
                </el-input>
              </div>

              <div class="custom-search-box-warpper">
                <span>负责人</span>
                <el-select
                  v-model="order.leaderId"
                  filterable
                  placeholder="请选择"
                  size="small"
                  :disabled="
                    edit == false || order.pond != '' || Boolean(orderId)
                  "
                  @change="changeEmlopyee"
                >
                  <el-option
                    v-for="item in companyUser"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="custom-search-box-warpper">
                <span>饲料名称</span>
                <el-select
                  v-model="order.productId"
                  filterable
                  placeholder="请选择"
                  :disabled="(!order.leaderId && !orderId) || isDisCost || isAutoOrder"
                  @change="changeFeedName"
                >
                  <el-option
                    v-for="item in feedNameList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="custom-search-box-warpper">
                <span>用量</span>
                <el-input
                  placeholder="请输入用量"
                  v-model="order.price"
                  :disabled="(!order.leaderId && !orderId) || isDisCost || isAutoOrder"
                  @input="priceBlur"
                  size="small"
                >
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="table-container"
        :class="{ 'auto-lock': isAutoOrder }"
        @click="onLockedAreaClick"
      >
        <table-ex
          :showIndex="true"
          :enable="enableTable && edit"
        >
          <thead-ex>
            <th-ex v-if="order.pond == ''">塘口</th-ex>
            <th-ex v-if="order.pond == ''">周期</th-ex>
            <th-ex>饲料名称</th-ex>
            <th-ex>本场计量</th-ex>
            <th-ex>饲料来源</th-ex>
            <th-ex>成本均价</th-ex>
            <th-ex>用量</th-ex>
          </thead-ex>
          <tbody-ex>
            <tr-ex
              v-for="(item, index) in order.details"
              :key="index"
              @selected="selectedRow = item"
            >
              <td-ex
                v-if="order.pond == ''"
                v-model="item.pond"
                :editable="item.pondEdit"
                :list="fishPondList"
                display="value"
                take="key"
                type="cmb"
                @selected="pondChange(item)"
              ></td-ex>
              <td-ex
                v-if="order.pond == ''"
                :key="`batch-${index}-${item.pond}`"
                class="allow-edit"
                v-model="item.fishBatchId"
                :editable="edit"
                :list="item.batchList"
                display="value"
                take="key"
                type="cmb"
                @selected="batchChange(item)"
              ></td-ex>
              <td-ex
                v-model="item.productId"
                type="cmb"
                :editable="!isAutoOrder"
                :list="feedNameList"
                display="name"
                take="id"
                @selected="fishChange(item)"
              ></td-ex>
              <td-ex
                v-model="item.measureUnit"
                type="text"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              ></td-ex>
              <td-ex
                v-model="item.dealerId"
                type="cmb"
                :editable="!isAutoOrder"
                :list="item.leaderList"
                display="dealerName"
                take="dealerId"
                @selected="leaderChange(item)"
              ></td-ex>
              <td-ex
                v-model="item.price"
                type="text"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              ></td-ex>
              <td-ex
                v-model="item.quantity"
                type="number"
                number
                :editable="!isAutoOrder"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                positive
                :decimalLength="2"
              ></td-ex>
            </tr-ex>
          </tbody-ex>
          <tfoot-ex
            v-model="order.remark"
            :disabled="isAutoOrder"
            @addRow="addRow"
            @delRow="delRow"
          >
            <td>合计</td>
            <td v-if="order.pond == ''">--</td>
            <td v-if="order.pond == ''">--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>{{ total("quantity") }}</td>
          </tfoot-ex>
        </table-ex>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "@/common/MixIn.js";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
export default {
  mixins: [mixins],
  name: "addFeeding",
  data () {
    return {
            // 限制日期
      pickerTimeOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      addBaseList: true,
      editBaseList: false,
      num: 3,
      show: false,
      orderId: this.$route.query.id,
      order: {
        fishBaseId: null,
        leaderId: null,
        warehouseId: null,
        warehouseName: "",
        pond: "",
        fishBatch: "",
        fishBatchId: "",
        dataDate: new Date(),
        numericalOrder: 0,
        billsNo: 0,
        remark: "",
        details: [],
        price: 0,
      },
      baseLists: [], //基地列表
      companyUser: [], //负责人
      fishPondList: [], //塘口
      topPondList: [],
      pondBatchList: [], //当前塘口的全部养殖周期
      feedNameList: [], //饲料列表
      storeHouseList: [], //仓库
      leaderList: [], // 饲料来源
      enableTable: false,
      selectedRow: null,
      emptyRow: {
        pond: null,
        fishBatch: null,
        fishBatchId: null,
        batchList: [],
        productId: null,
        productName: "",
        dealerId: null,
        dealerName: "",
        measureUnit: "",
        quantity: 0,
        remark: "",
        price: "",
      },

      categoryId: 10001,
      // 所有塘口
      allPondList: [],
      isDisCost: false,
    };
  },
  computed: {
    ...mapState(["loginUser"]),
    // 由饲料采购单自动生成的单据，仅允许修改周期
    isAutoOrder () {
      return Boolean(this.order && this.order.relevancyId);
    },
  },
  async mounted() {
    await this.initPagePermission();
    if (this.$route.query.id) {
      document.title = this.edit ? "编辑投喂管理" : "查看投喂管理";
    } else {
      document.title = "增加投喂管理";
    }
    let result = await Promise.all([
      this.getBaseList(),
      this.getEmployees(),
      this.getStoreHouse(),
    ]);
    this.baseLists = result[0];
    // 开始
    // this.companyUser = result[1];
    // this.companyUser.unshift({
    //   id: "",
    //   mobilePhone: "",
    //   phone: "",
    //   realName: "全部",
    //   name: "全部",
    // });
    // this.order.leaderId = result[1][0].id;
    // 结束
    this.storeHouseList = result[2];
    // console.log("负责人默认当前用户", this.companyUser);

    // this.order.leaderId = this.companyUser[0].id; //负责人默认当前用户
    if (this.storeHouseList.length > 0) {
      this.order.warehouseId = this.storeHouseList[0].warehouseID;
      this.order.warehouseName = this.storeHouseList[0].warehouseName;
    }
    // 添加基地默认项与 记住选中基地
    let addFeedingBase = storage.get("base");
    let oldBase = this.baseLists.find((f) => f.key == addFeedingBase);
    if (oldBase) {
      this.order.fishBaseId = oldBase.key;
      await this.baseChange(this.order.fishBaseId);
    } else if (this.baseLists.length > 0) {
      this.order.fishBaseId = this.baseLists[0].key;
      await this.baseChange(this.order.fishBaseId);
    }

    let allPond = await this.$api.getAllPondList();
    this.allPondList = allPond.data;
    // 开始
    this.getEmployeesByFishBaseList();
    this.initData(); //初始化表格
  },
  methods: {
    ...mapActions(modules.feeding, {
      addFeeding: "addFeeding", //添加
      updateFeeding: "updateFeeding", //修改
      updateFeedingBatch: "updateFeedingBatch", //修改养殖周期
      getEditFeeding: "getEditFeeding", //编辑--获取行数据
      delFeeding: "delFeeding", //删除
      getFeedLeaderData: "getFeedLeaderData", //来源
      getLayPrice: "getLayPrice", //获取成本均价
    }),
    ...mapActions(modules.proofing, {
      getPondUnclearedBatchNo: "getPondUnclearedBatchNo", //周期批次
      getPondBatchList: "getPondBatchList", //塘口全部养殖周期
    }),
    ...mapActions(modules.cultureCycle, {
      addFishBatch: "addFishBatch",
    }),
    ...mapActions(modules.fish, {
      // getFeedNameList: "getFeedNameList", //饲料名称
      getFeedName: "getFeedName", //饲料名称
    }),
    ...mapActions(modules.storeHouse, {
      getStoreHouse: "getStoreHouse", //仓库
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond", //塘口
      getEditPondData: "getEditPondData", //获取塘口设置单行数据
    }),
    ...mapActions(modules.base, {
      getBaseList: "getBaseList", //基地
    }),
    ...mapActions({
      getSerialNumber: "getSerialNumber",
    }),
    ...mapActions(modules.user, ["getEmployees", "getEmployeesByFishBase"]), //获取负责人数据
    ...mapActions(["delVisitedViews"]),
    // 获取当前基地下的负责人员工列表
    async getEmployeesByFishBaseList () {
      const result = await this.getEmployeesByFishBase(this.order.fishBaseId);
      this.companyUser = result;
      this.companyUser.unshift({
        id: "",
        mobilePhone: "",
        phone: "",
        realName: "全部",
        name: "全部",
      });
      this.$forceUpdate();
      if (this.orderId) return;
      this.order.leaderId = result[0].id;
    },
    // 选择负责人
    changeEmlopyee (e) {
      this.fishPondList = [];
      this.getPondListByEmployee(e);
      this.order.productId = "";
      this.order.price = 0;
      this.order.details.map((item) => {
        item.pond = "";
        item.fishBatch = "";
        item.fishBatchId = "";
        item.rate = "";
        item.costTypeId = "";
        item.amount = "";
      });
      // this.fishPondList = this.allPondList;
    },

    // 根据员工ID，获取对应员工底下塘口Id和塘口面积
    async getPondListByEmployee (id) {
      let res = await this.$api.getPondListByEmployee(
        id,
        this.order.fishBaseId
      );
      let list = res.data.list;
      this.fishPondList = list.map((pond) => {
        return {
          key: pond.pondId,
          value: this.allPondList.find((item) => item.key == pond.pondId).value,
          rate: pond.rate,
        };
      });
      if (list.length > 0) {
        if (this.orderId) {
          // 编辑情况
          if (list.length > this.order.details.length) {
            this.addRow();
          }
        }
        list.map((item, index) => {
          this.$nextTick(() => {
            this.order.details[index].pond = item.pondId;
            this.order.details[index].fishBatch = item.fishBatchValue;
            this.order.details[index].fishBatchId = item.fishBatchId;
            this.order.details[index].rate = item.rate;
          });
        });
      } else {
        this.fishPondList = [];
      }
    },

    // 获取用量失去焦点
    priceBlur (e) {
      this.order.details.map((item) => {
        if (item.pond) {
          item.quantity = (item.rate * this.order.price).toFixed(0);
        }
      });
    },

    // 选择费用名称
    async changeFeedName (e) {
      // 获取饲料名称 本场计量 饲料来源
      let obj = {
        fishBaseId: this.order.fishBaseId,
        productId: e,
      };

      let feedLeaderData = await this.getFeedLeaderData(obj);

      // 获取成本均价
      let priceData = await this.getLayPrice({
        productId: e,
        fishBaseId: this.order.fishBaseId,
      });

      // 循环赋值
      this.order.details.map((item) => {
        if (item.pond) {
          item.measureUnit = "";
          item.leaderId = "";
          let feedItem = this.feedNameList.find((f) => f.id == e);
          item.productName = feedItem.name;
          item.productId = e;
          item.measureUnit = feedItem.unit;
          item.scalingFactor = feedItem.scalingFactor;
          if (feedLeaderData) {
            item.leaderList = feedLeaderData;
            item.dealerId = feedLeaderData[0].dealerId;
            item.dealerName = feedLeaderData[0].dealerName;
          }
          if (priceData) {
            item.price = priceData.toFixed(2);
          }
        }
      });
    },

    //总计
    total (prop) {
      let total = 0;
      this.order.details.forEach((item) => (total += Number(item[prop])));
      return total.toFixed(2);
    },
    isAllEqual (array, val) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value[val] !== array[0][val];
        });
      } else {
        return true;
      }
    },
    //初始化表格
    initTable () {
      this.order.details = [];
      this.$nextTick(() => this.addRow());
    },
    // 获取塘口下的全部养殖周期
    async loadPondBatchList (pondId) {
      if (!pondId) return [];
      const result = await this.getPondBatchList(pondId);
      return (result || []).map((item) => ({
        key: item.key,
        value: String(item.value),
      }));
    },
    // 表头--切换周期(单塘口)
    headerBatchChange (batchId) {
      let item = this.pondBatchList.find((f) => f.key == batchId);
      // 用 $set 确保 order 上的周期字段是响应式的（编辑接口返回的对象没有该字段）
      this.$set(this.order, "fishBatchId", item ? item.key : "");
      this.$set(this.order, "fishBatch", item ? item.value : "");
      // 单塘口模式下明细共用表头周期
      (this.order.details || []).forEach((f) => {
        f.fishBatchId = batchId;
        f.fishBatch = this.order.fishBatch;
      });
    },
    // 表格--切换周期
    batchChange (row) {
      let item = (row.batchList || []).find((f) => f.key == row.fishBatchId);
      row.fishBatch = item ? item.value : "";
    },
    // 采购单自动生成的单据：点击周期以外的字段时提示
    onLockedAreaClick (e) {
      if (!this.isAutoOrder) return;
      let el = e.target;
      let inField = false;
      let allowEdit = false;
      while (el && el !== document.body) {
        if (el.classList) {
          if (el.classList.contains("allow-edit")) allowEdit = true;
          if (
            el.classList.contains("custom-search-box-warpper") ||
            el.classList.contains("tableUnit") ||
            el.classList.contains("addRow")
          ) {
            inField = true;
          }
        }
        el = el.parentElement;
      }
      if (!inField || allowEdit) return;
      Message.error(
        "由饲料采购单自动生成的喂养单不允许修改，请直接修改饲料采购单"
      );
    },
    //初始化数据
    async initData () {
      if (!this.orderId) {
        //新增
        this.order.numericalOrder = await this.getSerialNumber();
        this.topPondList = await this.getFishPond(this.order.fishBaseId);
        this.topPondList.unshift({
          key: "",
          value: "全部",
        });
        this.initTable();
      } else {
        //修改
        let result = await this.getEditFeeding(this.orderId);
        this.order.fishBaseId = result.fishBaseId;
        this.order.leaderId = result.leaderId || result.chargePersonId;
        this.$forceUpdate();
        this.order.warehouseName = result.warehouseName;
        if (this.order.leaderId) {
          this.fishPondList = this.allPondList;
        } else {
          await this.baseChange(result.fishBaseId);
          this.fishPondList = await this.getFishPond(result.fishBaseId);
        }
        // 判断是不是同一个费用
        let isSomeCostType = this.isAllEqual(result.details, "productId");
        if (isSomeCostType) {
          setTimeout(() => {
            this.order.productId = result.details[0].productId;
            this.isDisCost = false;
          }, 500);
        } else {
          this.isDisCost = true;
        }
        this.feedNameList = await this.getFeedName(result.fishBaseId);
        result.details.forEach(async (item) => {
          item.quantity = item.quantity.toFixed(2);
          // let as = [
          //   {
          //     id: item.productId,
          //     name: item.productName,
          //     unit: item.measureUnit
          //   }
          // ];
          // this.feedNameList = this.feedNameList.map(
          //   f => (f.productId === item.productId ? as : f)
          // ); //更新某一个对象数组
          let result = await Promise.all([
            this.getLayPrice({
              productId: item.productId,
              fishBaseId: this.order.fishBaseId,
            }),
            this.getFeedLeaderData({
              fishBaseId: this.order.fishBaseId,
              productId: item.productId,
            }),
          ]);
          //item.price = result[0].toFixed(2);
          // 来源、周期列表都是接口里没有的字段，用 $set 保证响应式
          this.$set(item, "leaderList", result[1]);
          this.$set(
            item,
            "batchList",
            item.fishPondId ? await this.loadPondBatchList(item.fishPondId) : []
          );
          item.dealerId = item.dealerId.toString();
          item.pondEdit = false;
          item.fishEdit = false;
          item.pond = item.fishPondId;
          item.fishBatch = item.fishBatchName;
          item.productId = item.productId;
        });
        this.order = result;
        this.orderId = result.orderId;
        this.enableTable = true;
        this.topPondList = await this.getFishPond(result.fishBaseId);
        this.topPondList.unshift({
          key: "",
          value: "全部",
        });
        // 编辑接口返回的数据里没有 pond / fishBatch / fishBatchId，必须用 $set 追加
        if (result.fishPondId === null) {
          this.$set(this.order, "pond", "");
        } else {
          this.$set(this.order, "pond", result.fishPondId);
          this.$set(this.order, "fishBatch", result.details[0].fishBatchName);
          this.$set(this.order, "fishBatchId", result.details[0].fishBatchId);
          this.pondBatchList = await this.loadPondBatchList(result.fishPondId);
        }
        console.log(this.fishPondList);
      }
    },
    //改变基地数据
    async baseChange (e) {
      storage.set("base", e);
      this.getFeedName(e)
        .then((data) => {
          this.feedNameList = data;
        })
        .catch(() => { });

      this.getFishPond(e)
        .then((data) => {
          this.fishPondList = data;
          if (this.fishPondList.length === 0) {
            this.$Alert.info({
              content: "当前选择的基地下面无塘口，请先添加",
              duration: 5000,
              status: "error",
            });
          }
        })
        .catch(() => { });

      this.enableTable = true;
      this.order.details.forEach((f) => {
        f.pond = null;
        f.fishBatchId = null;
        f.fishBatch = null;
        f.batchList = [];
      });
      if (!this.orderId) {
        this.topPondList = await this.getFishPond(e);
        this.$set(this.order, "pond", "");
        this.pondBatchList = [];
        this.topPondList.unshift({
          key: "",
          value: "全部",
        });
      }
    },
    //饲料名称数据
    async fishChange (e) {
      e.measureUnit = "";
      e.leaderId = null;
      let item = this.feedNameList.find((f) => f.id == e.productId);
      if (item) {
        e.productName = item.name;
        e.measureUnit = item.unit;
        e.scalingFactor = item.scalingFactor;
      }

      let obj = {
        fishBaseId: this.order.fishBaseId,
        productId: e.productId,
      };

      if (e.productId) {
        await this.getFeedLeaderData(obj)
          .then((data) => {
            if (data.length != 0) {
              e.leaderList = data;
              e.dealerId = e.leaderList[0].dealerId;
              e.dealerName = e.leaderList[0].dealerName;
            }
          })
          .catch((err) => {
            console.log(err);
          });
        let p = await this.getLayPrice({
          productId: e.productId,
          fishBaseId: this.order.fishBaseId,
        });
        e.price = p.toFixed(2);
        // console.log(8971, e.price);
      }
    },
    // 来源
    leaderChange (e) {
      let item = e.leaderList.find((f) => f.dealerId == e.dealerId);
      if (item) {
        e.dealerName = item.dealerName;
      }
    },
    async topPondChange (e) {
      if (e > 0) {
        this.pondBatchList = await this.loadPondBatchList(e);
        let result = await this.getPondUnclearedBatchNo(e);
        let { data: getEditPondDataResult } = await this.getEditPondData(e);
        this.$set(this.order, "leaderId", getEditPondDataResult.leaderId);
        if (result) {
          this.$set(this.order, "fishBatch", result.value);
          this.$set(this.order, "fishBatchId", result.key);
        } else {
          try {
            await MessageBox.confirm(
              "当前塘口尚未开启新的养殖周期，是否开启？",
              "提示"
            );
            try {
              await this.addFishBatch({
                fishPondId: e,
                batch: 0,
                startDate: this.order.date,
              });
              let newBatch = await this.getPondUnclearedBatchNo(e);
              this.$set(this.order, "fishBatchId", newBatch.key);
              this.$set(this.order, "fishBatch", newBatch.value);
              this.pondBatchList = await this.loadPondBatchList(e);
            } catch (error) {
              this.$set(this.order, "pond", "");
              this.$Alert.info({
                content: "开启新周期失败",
                duration: 5000,
                status: "error",
              });
              // Message.error("开启新周期失败");
            }
          } catch (error) {
            this.$set(this.order, "pond", "");
          }
        }
      } else {
        this.$set(this.order, "fishBatch", "");
        this.$set(this.order, "fishBatchId", "");
        this.pondBatchList = [];
      }
    },
    //改变塘口--联动周期
    async pondChange (row) {
      if (!row.pond) {
        //当什么都没有选中，则清理
        row.fishBatchId = null;
        row.fishBatch = null;
        row.batchList = [];
        return;
      }
      console.log(this.fishPondList, row, 233);
      row.rate = this.fishPondList.find((pond) => pond.key == row.pond).rate;
      this.$set(row, "batchList", await this.loadPondBatchList(row.pond));
      let result = await this.getPondUnclearedBatchNo(row.pond);
      if (result) {
        row.fishBatchId = result.key;
        row.fishBatch = result.value;
      } else {
        try {
          await MessageBox.confirm(
            "此塘口已清塘，是否开启新的养殖周期？",
            "提示"
          );
          try {
            await this.addFishBatch({
              fishPondId: row.pond,
              batch: 0,
              startDate: this.order.dataDate,
            });
            let newBatch = await this.getPondUnclearedBatchNo(row.pond);
            row.fishBatchId = newBatch.key;
            row.fishBatch = newBatch.value;
            this.$set(row, "batchList", await this.loadPondBatchList(row.pond));
          } catch (error) {
            row.pond = null;
            row.batchList = [];
            this.$Alert.info({
              content: "开启新周期失败",
              duration: 5000,
              status: "error",
            });
            // Message.error("开启新周期失败");
          }
        } catch (error) {
          row.pond = null;
          row.batchList = [];
        }
      }
    },
    //保存
    async onSave () {
      // 由饲料采购单自动生成的单据，仅允许修改周期
      if (this.isAutoOrder) {
        await this.onSaveBatch();
        return;
      }
      let err = null;
      if (this.$store.state.curCompany.isQlwVersion == true) {
        this.order.warehouseId = this.storeHouseList.find(
          (f) => f.warehouseName == this.order.warehouseName
        ).warehouseID;
      }
      this.order.chargePersonId = this.order.leaderId;
      if (!this.order.fishBaseId) err = "基地必须选择";
      if (!this.order.dataDate) err = "日期必须选择";
      if (!this.order.leaderId) err = "负责人必须选择";
      // if (this.$store.state.curCompany.isQlwVersion == true) {
      //   if (!this.order.warehouseId) err = "仓库必须选择";
      // }

      // let list = this.order.details.filter(
      //   f => JSON.stringify(f) != JSON.stringify(this.emptyRow)
      // );
      let list = [];
      if (this.order.pond == "") {
        list = this.order.details.filter((f) => {
          return f.pond !== "" && f.pond !== null;
        });
      } else {
        list = this.order.details.filter((f) => {
          return f.productId !== "" && f.productId !== null;
        });
        list.map((item) => {
          item.pond = this.order.pond;
          item.fishBatch = this.order.fishBatch;
          item.fishBatchId = this.order.fishBatchId;
        });
      }
      let quantityReg = /^[0-9]{1,4}([.][0-9]{1,2})?$/; //用量
      if (list.length == 0) err = "不能提交空表单";
      list.forEach((item) => {
        if (item.quantity === 0) {
          err = "请输入用量";
        }
        if (!quantityReg.test(item.quantity)) {
          err = "用量范围为0~9999.00";
        }
        if (!item.pond) err = "塘口必须选择";
        if (!item.fishBatch || !item.fishBatchId) err = "批次必须选择";
        if (!item.productId || !item.productName) err = "饲料名称必须选择";
        // if (!item.dealerId) err = "来源必须选择";
      });

      if (err) {
        Message.error(err);
        return;
      }
      if (list.length > 0) this.order.details = list;
      this.$nextTick(async () => {
        try {
          if (this.orderId) {
            let result = await this.updateFeeding({
              id: this.orderId,
              data: this.order,
            });
            this.order.billsNo = result.billNo;
            this.orderId = result.orderId;
            this.$message({
              message: "保存成功",
              type: "success",
            });
          } else {
            let result = await this.addFeeding(this.order);
            this.orderId = result.orderId;
            this.order.billsNo = result.billNo;
            this.$message({
              message: "保存成功",
              type: "success",
            });
          }
          this.enableTable = false;
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error",
          });
          // Message.error(error.response.data);
        }
      });
    },
    // 采购单自动生成的单据--仅保存周期
    async onSaveBatch () {
      if (!this.orderId) {
        Message.error("未找到订单Id，无法保存");
        return;
      }
      let details = (this.order.details || []).filter((f) => f.id);
      if (details.length == 0) {
        Message.error("未找到可保存的明细");
        return;
      }
      if (details.some((f) => !f.fishBatchId)) {
        Message.error("周期必须选择");
        return;
      }
      try {
        let result = await this.updateFeedingBatch({
          id: this.orderId,
          data: details.map((f) => ({
            detailId: f.id,
            fishBatchId: f.fishBatchId,
          })),
        });
        this.order.billsNo = result.billNo;
        this.orderId = result.orderId;
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.enableTable = false;
      } catch (error) {
        this.$Alert.info({
          content: error.response ? error.response.data : "保存失败",
          duration: 5000,
          status: "error",
        });
      }
    },
    onAlter () {
      this.enableTable = true;
      this.edit = true;
      if (this.orderId) {
        this.order.details.forEach((item) => {
          item.pondEdit = false;
          item.fishEdit = false;
        });
      }
    },
    onAdd () {
      this.order.billsNo = 0;
      // 新增单据不再关联原采购单
      this.order.relevancyId = 0;
      this.orderId = null;
      this.enableTable = true;
      this.pondBatchList = [];
      this.$nextTick(() => this.initData());
    },
    async onDelete () {
      if (!this.orderId) {
        await this.$Alert.info({
          content: "未找到订单Id，无法删除",
          duration: 5000,
          status: "error",
        });
        // await Message.error("未找到订单Id，无法删除");
        return;
      }
      try {
        await MessageBox.confirm("是否删除此订单？", "提示");
        try {
          await this.delFeeding(this.orderId);
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.orderId = null;
          this.enableTable = true;
          this.$nextTick(() => this.initTable());
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error",
          });
          // this.$message.error(error.response.data);
        }
      } catch (err) {
        console.log("取消删除");
      }
    },
    onRollBack () {
      this.initData();
      this.edit = false;
      this.enableTable = false;
    },
    addRow () {
      let list = [];
      for (let i = 0; i < 5; i++) {
        list.push(JSON.parse(JSON.stringify(this.emptyRow)));
      }
      this.order.details = this.order.details.concat(list);
    },
    delRow () {
      this.order.details = this.order.details.filter(
        (f) => f != this.selectedRow
      );
    },
    closeView () {
      this.delVisitedViews([
        {
          meta: { affix: false },
          path: this.$route.path,
          title: this.$route.meta.title,
        },
      ]);
      this.$router.replace("/productionControl/feedingManagement");
    },
  },
};
</script>
<style>
.danger-color {
  color: #fff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}
/* .readonlys input {
  pointer-events: none;
  background: #f5f7fa;
} */

.base-search-box-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.base-search-box .base-pond-box {
  margin-left: 20px;
}

.base-pond-box .pond-batch-label {
  margin: 0 12px 0 20px;
  font-size: 16px;
  color: rgba(102, 102, 102, 1);
  white-space: nowrap;
}

/* 自动生成的单据：禁用控件不吞掉点击，便于点击时弹出提示 */
.auto-lock .el-input__inner:disabled,
.auto-lock .el-input__inner[readonly],
.auto-lock .tableUnit > input {
  pointer-events: none;
}
.auto-lock .custom-search-box-warpper:not(.allow-edit),
.auto-lock .tableUnit:not(.allow-edit) {
  cursor: not-allowed;
}

.base-search-box .base-pond-box .el-input {
  width: 150px !important;
  min-width: 150px !important;
}
</style>
